export default __webpack_public_path__ + "static/media/Tyler-Arthur-Resume-2021.be058739.pdf";